import { useEffect, useState } from "react";
import { fetchAuthors, genreLabel } from "../lib/api";

export default function Auteurs() {
  const [authors, setAuthors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAuthors()
      .then((data) => {
        setAuthors(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div data-testid="page-auteurs" className="pt-32 pb-20 px-6 md:px-12 lg:px-24 min-h-screen">
      <header className="mb-20 max-w-4xl">
        <p className="text-xs tracking-[0.3em] uppercase text-[#9E4735] font-body mb-6">
          Annuaire littéraire
        </p>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-[#1A1A1A] leading-[1.05] tracking-tight font-light mb-8">
          Nos <em className="text-[#2C402E]">auteurs</em>
        </h1>
        <p className="text-lg text-[#4A4A4A] font-body leading-relaxed max-w-2xl">
          Rencontrez les plumes qui font l'identité de notre maison. Romanciers,
          poètes, conteurs et historiens — autant de voix singulières à découvrir.
        </p>
      </header>

      {loading ? (
        <p className="text-[#757575] font-body" data-testid="loading-auteurs">Chargement…</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 md:gap-16">
          {authors.map((author, i) => (
            <article
              key={author.id}
              data-testid={`author-card-${author.id}`}
              className="fade-in-up group"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <div className="aspect-[3/4] overflow-hidden bg-[#F4F1EA] mb-6 relative">
                <img
                  src={author.photo_url}
                  alt={author.name}
                  loading="lazy"
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700"
                />
              </div>
              <h3 className="font-serif text-3xl text-[#1A1A1A] leading-tight mb-3">
                {author.name}
              </h3>
              <p className="text-[10px] tracking-[0.2em] uppercase text-[#9E4735] font-body mb-4">
                {author.genres.map(genreLabel).join(" · ")} · {author.books_count} livre{author.books_count > 1 ? "s" : ""}
              </p>
              <p className="text-sm text-[#4A4A4A] font-body leading-relaxed">
                {author.bio}
              </p>
              {author.latest_book && (
                <p className="text-xs text-[#757575] font-body italic mt-4">
                  Dernière parution : « {author.latest_book} »
                </p>
              )}
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
